import { render, staticRenderFns } from "./taskToEndProcess.vue?vue&type=template&id=a587d958&scoped=true&"
import script from "./taskToEndProcess.vue?vue&type=script&lang=js&"
export * from "./taskToEndProcess.vue?vue&type=script&lang=js&"
import style0 from "./taskToEndProcess.vue?vue&type=style&index=0&id=a587d958&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a587d958",
  null
  
)

export default component.exports